export const APP_NAME = 'LPA Scheme'
export const PERSIST_STORE_NAME = 'lpaschemeadmin'
export const REDIRECT_URL_KEY = 'redirectUrl'